import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { DropdownBaseComponent } from '../dropdown-base.component';
import { DropDownService } from '../dropdown.service';
import { EventService } from './../../../../shared/services/event/event.service';

@Component({
  selector: 'ngx-positive-rules-dropdown',
  templateUrl: '../template-dropdown.html'
})
export class PositiveRulesDropdownComponent extends DropdownBaseComponent implements OnInit, OnDestroy {

  cleanActiveRuleSubscription: Subscription;

  constructor(
    private readonly dropdownService: DropDownService,
    protected readonly translatorService: TranslatorService,
    protected readonly eventService: EventService,
  ) {
    super(translatorService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.cleanActiveRuleSubscription = this.eventService.subscribe('cleanPositiveRules', () => {
      this.clearSelectedItems();
    });

    this.dropDownSettings = this.dropdownService.getConfiguration(this.singleSelection);
    this.itemsData = [
      { id: '0', name: this.translatorService.trans('response.is_positive') },
      { id: '1', name: this.translatorService.trans('response.is_negative') },
    ];
  }

  getSelectedItemMappedToBoolean(): boolean {
    return this.selectedItems[0] && this.selectedItems[0].id === '1';
  }

  ngOnDestroy(): void {
    this.cleanActiveRuleSubscription.unsubscribe();
  }

}
